"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadBeforeEvents = exports.events = void 0;
exports.events = [
    "onMouseDown",
    "onScroll",
    "onInput",
    "onClick",
    "onKeyUp",
    "onKeyDown",
    "onFocus",
    "onImageUpload",
    "onAudioUpload",
    "onVideoUpload",
    "onImageUploadError",
    "onVideoUploadError",
    "onAudioUploadError",
    "onSave",
    "onSetToolbarButtons",
    "imageUploadHandler",
    "toggleCodeView",
    "toggleFullScreen",
    "showInline",
    "showController",
    "onCopy",
    "onCut",
    "onDrop",
    "onPaste",
];
exports.uploadBeforeEvents = [
    "onImageUploadBefore",
    "onVideoUploadBefore",
    "onAudioUploadBefore",
];
